<template>
  <div class="sidenav">
    <div v-if="user.company.status">
      <router-link class="success" :to="{name: 'clients_add', params: { statusId: 1, modalVideo: true }}"><i class="fa fa-fw fa-plus"></i> Novo cadastro</router-link>
      <template v-if="isCompanyAdmin() || isCompanyFinancial()">
        <router-link class="info" :to="{name: 'finances_dashboard', query: { buy_credit: 1}}">Comprar crédito</router-link>
      </template>
      <router-link :to="{name: 'home'}"><i class="fa fa-fw fa-home"></i>Home</router-link>
      <router-link :to="{name: 'clients_list'}">Cadastros</router-link>
      <router-link :to="{name: 'products_list'}">Produtos</router-link>
      <router-link :to="{name: 'orders_list'}">Pedidos</router-link>
      <router-link :to="{name: 'shopping_catalog'}">Shopping</router-link>
      <template v-if="isCompanyAdmin() || isCompanyFinancial()">
        <router-link :to="{name: 'company_details'}">Locadora</router-link>
        <router-link :to="{name: 'employees'}">Usuários</router-link>
        <router-link :to="{name: 'finances_dashboard'}">Financeiro</router-link>
      </template>
      <a v-on:click="handleLogout()"><i class="fa fa-fw fa-sign-out"></i> Sair</a>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'

  export default{
    name: 'PartialDrawerNavigation',
    data () {
      return {}
    },
    computed: {
      ...mapState({
        user: state => state.user
      })
    },
    mounted () {},
    methods: {
      handleLogout () {
        this.unsubscribeChannel()
        this.unsetUser()
        this.$router.push({name: 'login'})
      },
      ...mapActions(['unsetUser'])
    }
  }
</script>



// WEBPACK FOOTER //
// PartialDrawerNavigation.vue?748cf465